/// <amd-module name="SearchUI/Components/Callout/index" />
export * from 'SearchUI/Components/Callout/Callout';
export * from 'SearchUI/Components/Callout/Callout.Props';
